import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { NotificationService } from './notification/notification/notification.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Genie Games';
  private navigationSubscription: Subscription | null = null;

  constructor(
    public notificationService: NotificationService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.navigationSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        const navigation = event as NavigationEnd;
        const currentUrl = navigation.urlAfterRedirects || navigation.url;

        if (currentUrl === '/' || currentUrl === '/genie/journey/board') {
          const storageKey = `one-time-reload:${currentUrl}`;
          const alreadyReloaded =
            typeof window !== 'undefined' && window.sessionStorage.getItem(storageKey) === '1';

          if (!alreadyReloaded) {
            window.sessionStorage.setItem(storageKey, '1');
            window.location.reload();
          }
        }
      });
  }

  ngOnDestroy(): void {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
      this.navigationSubscription = null;
    }
  }

  // connect(): void {
  //   this._chatService.connect();
  //   this.isConnected = true;
  // }

  // sendMessage() {
  //   if (this._chatService.isConnected()) {
  //     this._chatService.send(this.msg);
  //     this.msg = '';
  //   } else {
  //     this.isConnected = false;
  //   }
  // }

  // clear(): void {
  //   this._chatService.clear();
  // }

  // disconnect(): void {
  //   this._chatService.disconnect()
  //   this.isConnected = false;
  // }
}
